import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { ArrowBackIcon } from "~/Components/Icons/Icons";
import { adminHttp } from "~/Admin/services/http";
import AdminGuestPreview from "./AdminGuestPreview";
import { connect } from "react-redux";

const AdminViewGuest = ({ match, event, ...props }) => {

    const [guest, setGuest] = useState(null);

    const endpoint = `/events/${event.id}/guests/${match.params.guest_id}`;

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {
                setGuest(res.data);
            });
    };

    useEffect(loadData, [event]);

    if (!guest) {
        return <></>
    }

    return (
        <div>
            <Link to={`/guests/registration/${match.params.id}`} className="btn btn-secondary btn-sm mb-4">
                <ArrowBackIcon classes="d-inline mr-2" />
                Back
            </Link>

            <div className="row">
                <div className="col-6">
                    <h2>{guest.first_name} {guest.last_name}</h2>
                </div>
            </div>

            <div className="row">
                <div className="col-4">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <h3>Personal Details</h3>
                            <div className="row">
                                <div className="col-4 font-weight-500 text-nowrap">Email</div>
                                <div className="col-8">
                                    {guest?.email || '-'}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 font-weight-500 text-nowrap">Phone</div>
                                <div className="col-8">
                                    {guest?.phone || '-'}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 font-weight-500 text-nowrap">Company</div>
                                <div className="col-8">
                                    {guest?.company || '-'}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-4 font-weight-500 text-nowrap">Job Title</div>
                                <div className="col-8">
                                    {guest?.job_title || '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-8">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <AdminGuestPreview guest={guest} loadData={loadData} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminViewGuest);
